import React, { useEffect, useState } from "react";
import { HeaderV2, FooterV2, HeroAboutSection, VisionSection, WorldsSection, VoiceSection, CommunitySection, ContactModal, PrivacyModal } from "./components";
import styles from "./HomePageV2.scss";

export function HomePageV2() {
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [privacyModalOpen, setPrivacyModalOpen] = useState(false);

  useEffect(() => {
    const qs = new URLSearchParams(location.search);

    if (qs.has("sign_in")) {
      const redirectUrl = new URL("/signin", window.location);
      redirectUrl.search = location.search;
      window.location = redirectUrl;
    } else if (qs.has("auth_topic")) {
      const redirectUrl = new URL("/verify", window.location);
      redirectUrl.search = location.search;
      window.location = redirectUrl;
    }
  }, []);

  // お問い合わせモーダルを開くイベントをリッスン
  useEffect(() => {
    const handleOpenContact = () => {
      setContactModalOpen(true);
    };

    window.addEventListener("openContactModal", handleOpenContact);
    return () => {
      window.removeEventListener("openContactModal", handleOpenContact);
    };
  }, []);

  // プライバシーポリシーモーダルを開くイベントをリッスン
  useEffect(() => {
    const handleOpenPrivacy = () => {
      setPrivacyModalOpen(true);
    };

    window.addEventListener("openPrivacyModal", handleOpenPrivacy);
    return () => {
      window.removeEventListener("openPrivacyModal", handleOpenPrivacy);
    };
  }, []);

  return (
    <div className={styles.homePageV2}>
      <HeaderV2 />

      <main className={styles.mainContent}>
        {/* Hero + About Section */}
        <HeroAboutSection />

        {/* Vision Section */}
        <VisionSection />

        {/* Worlds Section */}
        <WorldsSection />

        {/* Voice Section */}
        <VoiceSection />

        {/* Community Section */}
        <CommunitySection />
      </main>

      <FooterV2 />

      {/* Contact Modal */}
      <ContactModal isOpen={contactModalOpen} onClose={() => setContactModalOpen(false)} />

      {/* Privacy Modal */}
      <PrivacyModal isOpen={privacyModalOpen} onClose={() => setPrivacyModalOpen(false)} />
    </div>
  );
}
